import React from 'react'

const SubHeading = props => {
  const { heading, copy } = props
  return (
    <div className="mb-6">
      <h2 className="text-2xl font-semibold">{heading}</h2>
      {copy && copy ? (
        <div className="mt-2">
          <p className="text-lg">{copy}</p>
        </div>
      ) : null}
    </div>
  )
}

export default SubHeading
